module.exports = __webpack_public_path__ + "img/drugs.a0ca6fa9.png";